import { ChangeDetectionStrategy, Component, computed, inject, input, model, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ResponsiveService } from '../../../../services/responsive.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-header',
  imports: [CommonModule, RouterModule, MatButtonModule, MatIconModule],
  templateUrl: './header.component.html',
  styles: `
    

    .mdc-button:hover {
      cursor: pointer !important;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ResponsiveService]
})
export class HeaderComponent {
  data = input.required<any>();
  currentUrl = input.required<string>();
  isLoading = input.required<boolean>();
  sidenavOpened = model();

  dropdownMenuOpened = signal<'flex' | 'hidden'>('hidden');

  responsiveService = inject(ResponsiveService);

  logoSelectorSrc = computed(() => {
    return (this.currentUrl() === "/" && this.responsiveService.mediumWidth() && !this.isLoading()) ? this.data()?.logos?.white_logo : this.data()?.logos?.logo;
  })

  get isHomePage () {
    return this.currentUrl() === "/";
  }

  get isRouterLinkActive() {
    return this.currentUrl() === "/about-us" || this.currentUrl() === "/blogs";
  }

  toggleSidenav () {
    this.sidenavOpened.update((v) => !v);
  }
}
